export const backofficeRoles = [
  "exhibitor",
  "exhibitorCommercial",
  "organiser",
  "placeManager",
  "tourismOperator",
  "acExpo",
] as const;

export type BackofficeRole = (typeof backofficeRoles)[number];

export const backofficeRolesWithoutAcExpo = [
  "exhibitor",
  "exhibitorCommercial",
  "organiser",
  "placeManager",
  "tourismOperator",
] as const;

export type BackofficeRoleWithoutAcExpo =
  (typeof backofficeRolesWithoutAcExpo)[number];

export const isBackofficeRole = (s: string): s is BackofficeRole => {
  return backofficeRoles.includes(s as BackofficeRole);
};
